<template>
  <div ref="tab" class="travelExpenses-box">
    <div
      class="travelExpenses-headers"
      :class="'headers-background-'+travelExpensesInfo.applyStatus"
    >
      <headers
        :headInfo="{headUrl: travelExpensesInfo.dingDingPhotoPath, dingdingUserId:travelExpensesInfo.currentApplyDingDingId, userName: travelExpensesInfo.currentApplyEmployeeName, approver: travelExpensesInfo.nextApprover, approvalState: travelExpensesInfo.applyStatus }"
      ></headers>
    </div>
    <div ref="travelExpenses_tab" class="travelExpenses-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian-box">
      <div class="travelExpenses-info d_jump">
        <div class="travelExpenses-info-content">
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">报销公司</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.paymentCompanyName}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">核算部门</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.accountingDeptName}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">报销项目</div>
            <router-link
              v-if="travelExpensesInfo.projectType=='Business'"
              class="travelExpenses-info-value bg-color"
              :to="{name:'projectInfo',query:{projectCode:travelExpensesInfo.projectCode}}"
            >{{travelExpensesInfo.projectName}}</router-link>
            <div v-else class="travelExpenses-info-value">{{travelExpensesInfo.projectName}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">支出项目</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.payItemName}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">考核单元</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.financialDeptName}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">报销日期</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.reimDate|yyyy-MM-dd}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">报销金额</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.paymentAmount|NumFormat}}元</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">单据张数</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.invoiceCount}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">领款人</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.payeePersonName}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">领款账号</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.payeeAccount}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">领款开户行</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.payeeDepositBank}}</div>
          </div>

          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">出差日期</div>
            <div
              class="travelExpenses-info-value"
            >{{travelExpensesInfo.tripStartDate+"至" +travelExpensesInfo.tripEndDate}}</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">出差时长</div>
            <div class="travelExpenses-info-value">{{travelExpensesInfo.tripDayCount}}天</div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">摘要</div>
            <div
              class="travelExpenses-info-value"
              v-html="$options.filters.textareaToFormat(travelExpensesInfo.summary)"
            ></div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">实际用途</div>
            <div
              class="travelExpenses-info-value"
              v-html="$options.filters.textareaToFormat(travelExpensesInfo.actualReimSummary)"
            ></div>
          </div>
          <div class="travelExpenses-info-box">
            <div class="travelExpenses-info-label">附件</div>
            <div class="travelExpenses-info-value">
              <filebox message="暂无借款相关文档" :fileInfo="fileInfo"></filebox>
            </div>
          </div>
        </div>
        <div class="divide-line"></div>
        <!--出差详细信息开始-->
        <div class="travelExpenses-order">
          <div class="travelExpenses-order-label">出差申请详情</div>
          <div class="travelExpenses-table">
            <div class="tab-remark borderBottom">
              <div class="remark-label">事由</div>
              <div class="remark-value">{{travelExpensesInfo.busiTripExpApply.tripReason}}</div>
            </div>
            <div
              v-for="(busiTripExpItem,index) in travelExpensesInfo.busiTripExpApply.busiTripExpDetail"
              :key="index+150"
              class="tab-content"
            >
              <div class="tab-title">
                <!--起始地-->
                <label>{{busiTripExpItem.startAddress}}</label>
                <em class="icon_from_to"></em>
                <!--到达地-->
                <label>{{busiTripExpItem.endAddress}}</label>
              </div>
              <div class="travelExpenses-time">
                <label>{{busiTripExpItem.tripStartDate}}</label>至
                <label>{{busiTripExpItem.tripEndDate}}</label>
              </div>
              <div class="tab-row tab-value">
                <div class>出行方式</div>
                <div class>出差时长</div>
              </div>
              <div class="tab-row tab-value">
                <div class>{{busiTripExpItem.tripMode}}</div>
                <div class>{{busiTripExpItem.duration}}小时</div>
              </div>
            </div>
            <div class="tab-remark">
              <div class="remark-label">备注</div>
              <div class="remark-value">{{travelExpensesInfo.busiTripExpApply.tripRemark}}</div>
            </div>
          </div>
        </div>
        <!--出差详细信息结束-->
        <div class="divide-line"></div>
        <!--差旅费明细开始-->
        <div class="travelExpenses-order">
          <div class="travelExpenses-order-label">差旅费明细</div>
          <div class="travelExpenses-table">
            <div
              v-for="(detailMainItem,index) in travelExpensesInfo.detailMain"
              :key="index"
              class="tab-content"
            >
              <div class="tab-title">
                <!--起始地-->
                <label>{{detailMainItem.startPlace}}</label>
                <em class="icon_from_to"></em>
                <!--到达地-->
                <label>{{detailMainItem.endPlace}}</label>
                <p>{{detailMainItem.incurredDate}}</p>
                <!--日期-->
              </div>
              <div class="tab-row tab-value">
                <div class>单据张数</div>
                <div class>飞机</div>
                <div class>火车</div>
                <div class>汽车/轮船</div>
              </div>
              <div class="tab-row tab-value">
                <div class>{{detailMainItem.invoiceCount}}</div>
                <div class>{{detailMainItem.airplaneAmount|NumFormat('-')}}</div>
                <div class>{{detailMainItem.trainAmount|NumFormat('-')}}</div>
                <div class>{{detailMainItem.otherAmount|NumFormat('-')}}</div>
              </div>
            </div>
            <div class="tab-foot">
              <div class="tab-foot-title">其他费用</div>
              <!--其他费用-->
              <div
                class="tab-foot-box"
                v-for="(detailOtherItem,indexs) in travelExpensesInfo.detailOther"
                :key="indexs+30"
              >
                <div class="tab-foot-value">{{detailOtherItem.projectName}}</div>
                <div class="tab-foot-value">{{detailOtherItem.amount|NumFormat}}</div>
                <div class="tab-foot-value">单据</div>
                <div class="tab-foot-value">{{detailOtherItem.invoiceCount}}</div>
              </div>
            </div>
            <div class="tab-Total">合计：￥{{otherTotalPrice|NumFormat}}</div>
          </div>
        </div>
        <!--差旅费明细结束-->
        <div class="divide-line"></div>

        <div
          v-if="travelExpensesInfo.detailCarfare!=null&&travelExpensesInfo.detailCarfare.length>0"
        >
          <!--市内交通费开始-->
          <div class="travelExpenses-city-table">
            <p>市内交通费明细</p>
            <div
              v-for="(detailCarfareItem,_index) in travelExpensesInfo.detailCarfare"
              :key="_index+60"
              class="travelExpenses-city-row"
            >
              <div
                class="trip-time"
              >出行时间： {{detailCarfareItem.incurredDate+" "+detailCarfareItem.startTime+"~"+detailCarfareItem.endTime}}</div>
              <div class="trip-address">
                <div class="trip-address-box">
                  <div class="trip-address-label">出发地点</div>
                  <div class="trip-address-label">到达地点</div>
                  <div class="amount">金额</div>
                </div>
                <div class="trip-address-box">
                  <div class="trip-address-label">{{detailCarfareItem.startPlace}}</div>
                  <div class="trip-address-label">{{detailCarfareItem.endPlace}}</div>
                  <div class="amount">{{detailCarfareItem.amount|NumFormat}}</div>
                </div>
                <div class="travelExpenses-city-remark">
                  <div class="remark-label">事由:</div>
                  <div class="remark-value">{{detailCarfareItem.purpose}}</div>
                </div>
              </div>
            </div>
          </div>
          <!--市内交通费结束-->
          <div class="divide-line"></div>
        </div>

        <div v-if="travelExpensesInfo.detailPriCar!=null&&travelExpensesInfo.detailPriCar.length>0">
          <!--其他费用开始-->
          <div class="travelExpenses-city-table">
            <p>其他出行方式明细</p>
            <div
              v-for="(detailPriCarItem,_indexs) in travelExpensesInfo.detailPriCar"
              :key="_indexs+90"
              class="travelExpenses-city-row"
            >
              <div class="trip-time">出行时间： {{detailPriCarItem.incurredDate}}</div>
              <div class="trip-address">
                <div class="trip-address-box">
                  <div class="trip-address-label">出发地点</div>
                  <div class="trip-address-label">到达地点</div>
                  <div class="amount">费用合计</div>
                </div>
                <div class="trip-address-box">
                  <div class="trip-address-label">{{detailPriCarItem.startPlace}}</div>
                  <div class="trip-address-label">{{detailPriCarItem.endPlace}}</div>
                  <div class="amount">{{detailPriCarItem.totalAmount|NumFormat}}</div>
                </div>
                <div class="othen-cost">
                  <div>实际里程</div>
                  <div>{{detailPriCarItem.actualMileage}}</div>
                  <div>里程费</div>
                  <div>{{detailPriCarItem.mileagePayment}}</div>
                </div>
                <div class="othen-cost">
                  <div>路桥费</div>
                  <div>{{detailPriCarItem.roadPayment|NumFormat}}</div>
                  <div>停车费</div>
                  <div>{{detailPriCarItem.parkingPayment|NumFormat}}</div>
                </div>
                <div class="travelExpenses-city-remark">
                  <div class="remark-label">事由:</div>
                  <div class="remark-value">{{detailPriCarItem.purpose}}</div>
                </div>
              </div>
            </div>
          </div>
          <!--其他费用结束-->
          <div class="divide-line"></div>
        </div>

        <div v-if="travelExpensesInfo.detailAbroad!=null&&travelExpensesInfo.detailAbroad.length>0">
          <!--出国费用开始-->
          <div class="travelExpenses-abroad-table">
            <p>出国费用明细</p>
            <div
              v-for="(detailAbroadItem,cindex) in travelExpensesInfo.detailAbroad"
              :key="cindex+120"
              class="travelExpenses-abroad-content"
            >
              <div class="abstract-box">
                <div class="abstract-laber">摘要</div>
                <div class="abstract-value">{{detailAbroadItem.summary}}</div>
              </div>
              <div class="abstract-box">
                <div class="abstract-laber">发票时间</div>
                <div class="abstract-value">{{detailAbroadItem.incurredDate}}</div>
              </div>
              <div class="convert-amount">
                <div>外币币种</div>
                <div>{{detailAbroadItem.foreignCurrency}}</div>
                <div>外币金额</div>
                <div>{{detailAbroadItem.foreignAmount|NumFormat}}</div>
              </div>
              <div class="convert-amount">
                <div>外汇牌价</div>
                <div>{{detailAbroadItem.exchangeRate}}</div>
                <div>人民币金额</div>
                <div>{{detailAbroadItem.rmbAmount|NumFormat}}</div>
              </div>
              <div class="abstract-box">
                <div class="abstract-laber">备注</div>
                <div class="abstract-value">{{detailAbroadItem.remark}}</div>
              </div>
            </div>
          </div>
          <!--出国费用结束-->
          <div class="divide-line"></div>
        </div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="travelExpensesInfo.approvalList"
          :applyEmployeeID="travelExpensesInfo.applyEmployeeID"
        ></process>
      </div>
    </div>
    <div class="travelExpenses-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:travelExpensesInfo.nextApproveStep}"
        v-if="travelExpensesInfo.nextApproverId&&travelExpensesInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&travelExpensesInfo.applyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:travelExpensesInfo.nextApproverUserId,applyEmployeeName:travelExpensesInfo.currentApplyEmployeeName, applyTypeName:'差旅费报销申请'}"
        v-else-if="travelExpensesInfo.applyEmployeeID==userInfo.employeeID&&travelExpensesInfo.applyStatus=='SUBMIT'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template>
<script>
import headers from "@/components/Approval/ApprovalHead/index";
import tab from "@/components/Share/Tab";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import filebox from "@/components/Share/Preview/fileBox";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
export default {
  data() {
    return {
      otherTotalPrice: 0,
      paramInfo: {},
      travelExpensesInfo: {},
      fileInfo: {},
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "申请信息" },
          { key: 1, value: "审批信息" }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getPurchaseInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `/api/FD/travelExpenses/GetTravelExpensesApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.applyStatus,
                isMore: true
              });
              _this.fileInfo = {
                filesrcs: res.data.data.attachFilePath,
                filenames: res.data.data.attachFileName
              };
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    }
  },
  async mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.tabconfig.affixNum = _this.$refs.tab.offsetTop - 1;
      _this.$refs.travelExpenses_tab.style =
        "top:" + _this.tabconfig.affixNum + "px";
    });
    this.paramInfo = { ...this.$route.query };
    this.travelExpensesInfo = await this.getPurchaseInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
    if (
      this.travelExpensesInfo.detailOther &&
      this.travelExpensesInfo.detailOther.length > 0
    ) {
      this.otherTotalPrice = this.travelExpensesInfo.detailOther.reduce(
        (p, c, cindex, array) => {
          return { amount: p.amount + c.amount };
        }
      ).amount;
    }
  },
  components: {
    headers,
    tab,
    process,
    exefoot,
    selffoot,
    passfoot,
    filebox
  }
};
</script>

<style lang="less" scoped>
.travelExpenses-box {
  .travelExpenses-headers {
    padding: 0 0.4rem;
  }

  .travelExpenses-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian-box {
    padding-bottom: 1.6rem;
    .travelExpenses-info {
      .divide-line {
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .travelExpenses-info-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .travelExpenses-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .travelExpenses-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .travelExpenses-info-value {
            margin-left: 0.133333rem;
            width: 80%;
            color: #333333;
          }
          .bg-color{
            color: #55b9fc!important;
          }
        }
      }
      .travelExpenses-order {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .travelExpenses-order-label {
          height: 1.253333rem;
          line-height: 1.253333rem;
          font-size: 0.453333rem;
          color: #333333;
          font-weight: bold;
          border-bottom: 1px solid #eee;
        }
        .travelExpenses-table {
          margin-top: 0.533333rem;
          width: 100%;
          font-size: 0.373333rem;
          border: 1px solid #eee;
          .tab-content {
            .tab-row {
              width: 100%;
              height: 1.066667rem;
              line-height: 1.066667rem;
              display: flex;
              border-bottom: 1px solid #eee;
              .tab-cell-first {
                width: 1.333333rem;
                border-right: 1px solid #eee;
              }
              .tab-cell {
                flex: 1;
              }
            }
            .tab-title {
              height: 1.333333rem;
              text-align: center;
              font-weight: bold;
              border-bottom: 1px solid #eee;
              padding-top: 0.133333rem;
              p {
                text-align: right;
                margin-right: 0.266667rem;
              }
              label {
                vertical-align: middle;
              }
              .icon_from_to {
                display: inline-block;
                background-image: url("../../../assets/icon/fromto.png");
                -moz-background-size: 100% 100%;
                background-size: 100% 100%;
                width: 1.173333rem;
                height: 0.16rem;
                margin: 0 0.133333rem 0.066667rem;
                vertical-align: middle;
              }
            }
            .tab-value {
              text-align: center;
              div {
                flex: 1;
                border-right: 1px solid #eee;
              }
            }
          }
          .tab-foot {
            width: 100%;
            .tab-foot-title {
              width: 100%;
              height: 1.066667rem;
              line-height: 1.066667rem;
              text-align: center;
              font-weight: bold;
              border-bottom: 1px solid #eee;
            }
            .tab-foot-box {
              display: flex;
              flex-wrap: wrap;
              .tab-foot-value {
                width: 25%;
                height: 1.066667rem;
                line-height: 1.066667rem;
                text-align: center;
                border-right: 1px solid #eee;
              }
            }
          }
          .tab-Total {
            width: 100%;
            height: 1.333333rem;
            line-height: 1.333333rem;
            border-top: 1px solid #eee;
            color: #333333;
            font-weight: bold;
            padding-left: 0.266667rem;
          }
          .tab-remark {
            width: 100%;
            min-height: 1.333333rem;
            display: flex;
            .remark-label {
              width: 1.333333rem;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .remark-value {
              flex: 1;
              display: flex;
              align-items: center;
            }
          }
          .borderBottom {
            border-bottom: 1px solid #eee;
          }
          .travelExpenses-time {
            display: flex;
            justify-content: space-between;
            height: 1.333333rem;
            align-items: center;
            border-bottom: 1px solid #eee;
            padding: 0 0.133333rem;
          }
        }
      }
      .travelExpenses-city-table {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        font-size: 0.373333rem;
        p {
          height: 1.253333rem;
          line-height: 1.253333rem;
          font-size: 0.453333rem;
          color: #333333;
          font-weight: bold;
          border-bottom: 1px solid #eee;
        }
        .travelExpenses-city-row {
          margin-top: 0.533333rem;
          .trip-time {
            height: 1.066667rem;
            line-height: 1.066667rem;
          }
          .trip-address {
            border: 1px solid #eee;
            .trip-address-box {
              width: 100%;
              display: flex;
              .trip-address-label {
                min-height: 1.066667rem;
                flex: 1;
                border-bottom: 1px solid #eee;
                border-right: 1px solid #eee;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .amount {
                width: 1.6rem;
                min-height: 1.066667rem;
                border-bottom: 1px solid #eee;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
            .travelExpenses-city-remark {
              width: 100%;
              min-height: 1.333333rem;
              display: flex;
              .remark-label {
                width: 1.333333rem;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .remark-value {
                flex: 1;
                display: flex;
                align-items: center;
              }
            }
          }
          .othen-cost {
            display: flex;
            width: 100%;
            height: 1.066667rem;
            line-height: 1.066667rem;
            text-align: center;
            border-bottom: 1px solid #eee;
            div {
              flex: 1;
              height: 100%;
              border-right: 1px solid #eee;
            }
          }
        }
      }
      .travelExpenses-abroad-table {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        font-size: 0.373333rem;
        p {
          height: 1.253333rem;
          line-height: 1.253333rem;
          font-size: 0.453333rem;
          color: #333333;
          font-weight: bold;
          border-bottom: 1px solid #eee;
        }
        .travelExpenses-abroad-content {
          margin-top: 0.4rem;
          border: 1px solid #eee;
          .abstract-box {
            width: 100%;
            min-height: 1.066667rem;
            display: flex;
            border-bottom: 1px solid #eee;
            .abstract-laber {
              width: 2rem;
              border-right: 1px solid #eee;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .abstract-value {
              flex: 1;
              display: flex;
              align-items: center;
              padding: 0.066667rem 0.133333rem;
            }
          }
          .convert-amount {
            display: flex;
            width: 100%;
            height: 1.066667rem;
            line-height: 1.066667rem;
            text-align: center;
            border-bottom: 1px solid #eee;
            div {
              flex: 1;
              height: 100%;
              border-right: 1px solid #eee;
            }
          }
        }
      }
      .busiTripExp-order {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .busiTripExp-order-label {
          height: 1.253333rem;
          line-height: 1.253333rem;
          font-size: 0.453333rem;
          color: #333333;
          font-weight: bold;
          border-bottom: 1px solid #eee;
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .travelExpenses-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FD/TravelExpenses/index.vue